export default {
  tracker: {
    host: 'cn-beijing.log.aliyuncs.com',
    project: 'wuwei-editor',
    logstroe: 'front'
  }
}



// WEBPACK FOOTER //
// ./src/global.js